import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import IosShareIcon from '@mui/icons-material/IosShare';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { formatTimezoneLabel } from '../../../commons/utils/formatTimezone';
import * as styles from './styles';

function PublisherCard({ publisher, hotRank, onSync, onShare }) {
    const logoGradient = publisher.logoColors?.length >= 2
        ? `linear-gradient(135deg, ${publisher.logoColors[0]}, ${publisher.logoColors[1]})`
        : 'linear-gradient(135deg, #0078FF, #00D7FF)';

    function renderHeader() {
        return (
            <Box sx={styles.header}>
                {publisher.logo ? (
                    <Box
                        component="img"
                        src={publisher.logo}
                        alt={publisher.name}
                        sx={styles.logo}
                    />
                ) : (
                    <Box sx={{ ...styles.logo, background: logoGradient }}>
                        <Typography sx={styles.logoInitial}>
                            {publisher.name?.[0]}
                        </Typography>
                    </Box>
                )}

                <Box sx={styles.publisherInfo}>
                    <Typography sx={styles.publisherName}>
                        {publisher.name}
                    </Typography>
                    <Box sx={styles.categories}>
                        {publisher.industries?.slice(0, 2).map((cat) => (
                            <Typography key={cat} sx={styles.category}>{cat}</Typography>
                        ))}
                    </Box>
                </Box>

                <Button
                    onClick={() => onShare(publisher)}
                    aria-label={`Share ${publisher.name}`}
                    sx={styles.shareButton}
                >
                    <IosShareIcon sx={{ fontSize: 18 }} />
                </Button>
            </Box>
        );
    }

    function renderPills() {
        // publisher.rank is set within What's Hot itself; hotRank is the same
        // rank looked up via publisherStore.whatsHotPublisherIds for any other
        // section — either a number (rank known) or `true` (hot, rank unknown).
        const rank = publisher.rank ?? (Number.isFinite(hotRank) ? hotRank : null);
        const isHot = publisher.rank != null || hotRank != null;

        return (
            <Box sx={styles.pills}>
                {isHot && (
                    <Box sx={styles.pillHot}>
                        <LocalFireDepartmentIcon sx={{ fontSize: 11 }} />
                        {rank != null ? `#${rank}` : null}
                    </Box>
                )}
                <Typography sx={styles.timezone}>
                    <PlaceIcon sx={{ fontSize: 12, color: 'var(--ecal-lightblue)' }} />
                    {formatTimezoneLabel(publisher.timezone)}
                </Typography>
            </Box>
        );
    }

    function renderNextEvent() {
        return (
            <Box sx={styles.nextEvent}>
                {/* TODO: re-enable when next event data is available
                <Typography sx={styles.nextEventLabel}>Next event</Typography>
                <Typography sx={styles.nextEventTitle}>
                    {publisher.nextEvent?.title}
                </Typography>
                <Typography sx={styles.countdown}>
                    {publisher.nextEvent?.countdown}
                </Typography>
                */}
            </Box>
        );
    }

    function renderSyncButton() {
        return (
            <Button
                variant="contained"
                startIcon={<CalendarMonthIcon />}
                onClick={() => onSync(publisher)}
                sx={styles.syncButton}
            >
                {publisher.actionButton}
            </Button>
        );
    }

    return (
        <Box component="article" sx={styles.card}>
            {renderHeader()}
            {renderPills()}
            {renderNextEvent()}
            {renderSyncButton()}
        </Box>
    );
}

export default PublisherCard;
